/* eslint-disable max-lines-per-function */
/**
 * @file  Releases
 * @author yuanyaojia@baijia.com
 * @date 2021-04-21
 */

import React, {useEffect, useState, useRef, useContext} from 'react';
import {message, Pagination, Input, Select, Divider} from 'antd';
import {Picker} from 'antd-mobile';
import News from '~/component/News';
import IconFont from '~/component/Iconfont';
import {renderSelectOptions} from '~/utils/render';
import {yearSection} from '~/utils/function';
import {yearSelect, pageSection} from '~/utils/common';
import {getRecentNews} from '~/service/cms';
import {BasicLayoutContext} from '~/layout/BasicLayout';
import {DEFAULT_PAGE_NUM, DEFAULT_PAGE_SIZE} from '~/utils/http';

import './index.less';


const {Search} = Input;

function Releases() {
    const [year, setYear] = useState('');
    const [yearMobile, setYearMobile] = useState([]);
    const [title, setTitle] = useState('');
    const [pageDto, setPageDto] = useState({
        pageNum: DEFAULT_PAGE_NUM,
        pageSize: DEFAULT_PAGE_SIZE
    });
    const {pageNum} = pageDto;
    const [pageNumMobile, setPageNumMobile] = useState([]);
    const [list, setList] = useState([]);
    const [total, setTotal] = useState(0);
    const searchRef = useRef<any>();
    const [hasClick, setHasClick] = useState(false);
    const layoutContext = useContext(BasicLayoutContext);
    const {isMobile} = layoutContext ?? {};

    useEffect(() => {
        window.scrollTo(0, 0);
        getRecentNews({pageDto, year, title})
            .then(({data: {list, total}}) => {
                setList(list);
                setTotal(total);
            })
            .catch(() => {
                message.error('获取分页列表信息失败');
            });
    }, [year, title, pageDto]);

    function handleSearch(value) {
        setTitle(value);
    }

    function doSearch() {
        setTitle(searchRef.current.input.value);
    }

    function handleMenuClick(value) {
        if (isMobile) {
            setYear(value[0]);
            setYearMobile(value);
        }
        else {
            setYear(value);
        }
        setHasClick(false);
        setPageDto({
            pageNum: DEFAULT_PAGE_NUM,
            pageSize: DEFAULT_PAGE_SIZE,
        });
    }

    function handlePageChange(page, pageSize) {
        setPageDto({
            pageNum: page,
            pageSize
        });
    }

    function handlePageChangeMobile(value) {
        setPageDto({
            pageNum: value[0],
            pageSize: 20
        });
        setPageNumMobile(value);
    }

    function handClick() {
        setHasClick(true);
    }

    /**
     * 处理分页数据
     */
    const pageSelect = [];
    pageSelect.push(pageSection(total, DEFAULT_PAGE_SIZE));

    return (
        <div className="releases-content">
            {
                isMobile
                    ? (
                        <>
                            <div className="releases-content-title">
                                News Releases
                            </div>
                            <Divider />
                            <div className="releases-content-year-filter">
                                filter
                                <Picker
                                    data={yearSelect}
                                    cascade={false}
                                    okText="determine"
                                    dismissText="cancel"
                                    value={yearMobile}
                                    onChange={handleMenuClick}
                                >
                                    <div className="releases-content-year">
                                        {
                                            yearMobile.length === 0 || yearMobile[0] === '' ? 'All Year' : year
                                        }
                                        <IconFont type="iconxiala" className="iconxiala" />
                                    </div>
                                </Picker>
                            </div>
                            <Divider />
                            <Search
                                className="releases-content-search"
                                onSearch={handleSearch}
                                ref={searchRef}
                                bordered={false}
                                allowClear
                                placeholder="Search"
                                suffix={
                                    <IconFont onClick={doSearch} type="iconsousuo" />
                                }
                            />
                        </>
                    )
                    : (
                        <>
                            <div className="releases-btn">
                                <Select
                                    defaultValue=""
                                    onChange={handleMenuClick}
                                    onClick={handClick}
                                    suffixIcon={(
                                        <IconFont
                                            type="iconxiala"
                                            className={hasClick ? 'iconxiala-click' : 'iconxiala'}
                                        />
                                    )}
                                >
                                    {renderSelectOptions(yearSection())}
                                </Select>
                                <Search
                                    onSearch={handleSearch}
                                    ref={searchRef}
                                    allowClear
                                    placeholder="Search"
                                    suffix={
                                        <IconFont onClick={doSearch} type="iconsousuo" />
                                    }
                                />
                            </div>
                        </>

                    )
            }

            {
                list.map(item => <News key={item.id} id={item.id} item={item} />)
            }

            {
                isMobile
                    ? (
                        <>
                            <div className="releases-content-year-filter">
                                PaginationShow
                                <Picker
                                    data={pageSelect}
                                    cascade={false}
                                    okText="determine"
                                    dismissText="cancel"
                                    value={pageNumMobile}
                                    onChange={handlePageChangeMobile}
                                >
                                    <div className="releases-content-year">
                                        {pageNum}
                                        <IconFont type="iconxiala" className="iconxiala" />
                                    </div>
                                </Picker>
                            </div>
                            <Divider />

                            <div className="pagination-total-mobile">
                                {
                                    total > 0 && (
                                        <div className="total">
                                            Total Records:
                                            {' '}
                                            {total}
                                        </div>
                                    )
                                }
                            </div>
                        </>
                    )
                    : (
                        <div className="pagination-total">
                            {
                                total > 0 && (
                                    <div className="total">
                                        Total Records:
                                        {total}
                                    </div>
                                )
                            }

                            <Pagination
                                onChange={handlePageChange}
                                defaultPageSize={20}
                                defaultCurrent={1}
                                total={total}
                                current={pageNum}
                                showSizeChanger
                                hideOnSinglePage
                            />
                        </div>
                    )
            }
        </div>
    );
}

export default Releases;
